import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        circle: {
            width: 14,
            height: 14,
        },
        control: {
            width: 23,
            height: 23,
            borderRadius: '50%',
            background: theme.palette.primary[400],
            color: theme.palette.common.white,
            fontSize: theme.typography.h3.fontSize,
            alignSelf: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
        },

    }
})

export default useStyles
